export const SEARCH_MENU_LIST_ITEM_CLASS_NAME = 'search-menu-list-item'
